module.exports = __webpack_public_path__ + "static/media/Scale.b7672c59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Scale.svg
// module id = 96
// module chunks = 0